import schema from './schema';

export const release = {
  schema,
};
